import { type ReactNode, useState } from 'react';

import { Badge } from '~/components/ui/badge';
import { Icon } from '~/components/ui/icon';
import { cn } from '~/styles/extended-theme';

interface PurchaseSummaryItem {
  name: string;
  value: ReactNode;
  className?: string;
  valueClassName?: string;
}

interface PurchaseSummaryProps {
  purchaseName: string;
  purchaseItems: PurchaseSummaryItem[];
}

export function PurchaseSummary({ purchaseName, purchaseItems }: PurchaseSummaryProps) {
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);

  return (
    <div className="flex flex-col">
      <div className="tablet flex flex-col tablet:flex-row tablet:justify-between">
        <div className="mb-1.5 flex items-center gap-2 tablet:mb-0">
          <Badge variant="success" text="Active" />
          <p className="text-subtitle2">{purchaseName}</p>
        </div>
        <div className="flex items-center justify-between tablet:justify-normal">
          <p className="text-subtitle2 font-light">Summary</p>
          <Icon
            onClick={() => setIsSummaryOpen((prev) => !prev)}
            name="chevron-down"
            size="xl"
            className={`ml-2.5 transition-transform duration-200 hover:cursor-pointer ${
              isSummaryOpen ? 'rotate-180' : ''
            }`}
            aria-hidden
          />
        </div>
      </div>
      {isSummaryOpen ? (
        <div className="mt-2 flex flex-col gap-0.5 text-caption">
          {purchaseItems.map(({ name, value, className, valueClassName }) => (
            <div key={name} className={cn('flex justify-between', className)}>
              <p>{name}</p>
              <p className={cn('text-right', valueClassName)}>{value}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
